<template>
  <v-content>
    <v-container>
      <v-layout text-xs-center wrap class="text-center">
        <v-btn class="left info fill" to="/admin">Back</v-btn>

        <v-flex xs12>
          <div v-if="auditEvent === null">
            <h3>Audit Event</h3>

            <span>Audit Date:</span>
            <br />
            <span>Drug Name:</span>
            <br />
            <span>Project Designation:</span>
            <br />
            <span>Uploads Allowed:</span>
            <br />
            <span>Sharing Allowed:</span>
            <br />
            <span>Completed:</span>
            <br />
          </div>
          <div v-else>
            <h3>
              Audit Event
              <v-icon @click="editAuditEvent">edit</v-icon>
            </h3>
            <span
              >Audit Date:
              {{ moment(this.auditEvent.auditDate).format("MMMM YYYY") }}</span
            >
            <br />
            <span>Drug Name: {{ this.auditEvent.drugName }}</span>
            <br />
            <span
              >Project Designation:
              {{ this.auditEvent.projectDesignation }}</span
            >
            <br />
            <span>Uploads Allowed: {{ this.auditEvent.auditorActive }}</span>
            <br />
            <span>Sharing Allowed: {{ this.auditEvent.eventActive }}</span>
            <br />
            <span>Completed: {{ this.auditEvent.completed }}</span>
            <br />
            <span
              >Signature Required: {{ this.auditEvent.signatureRequired }}</span
            >
            <br />
          </div>

          <div>
            <h3>Photo Viewing Stats</h3>
            <v-btn
              @click="
                $router.push(
                  `/admin/viewStats/${auditEvent.sharingID}/${auditEvent.managerID}`
                )
              "
              >View</v-btn
            >
          </div>

          <div>
            <h3>Audit Sample Stats</h3>
            <div v-if="auditEvent !== null && stats !== null">
              <span>Nths completed / Total Nths (%)</span>
              <br />
              <span
                >{{ stats.auditSamplesWithPhotos }} /
                {{ stats.numberOfAuditSamples }} ({{
                  stats.auditSamplesWithPhotosPercentage
                }}%)</span
              >
            </div>
          </div>

          <v-col cols="12">
            <download-excel
              v-if="photos.length > 0 && loadingDownload"
              :data="downloadPhotos"
              :name="downloadName"
              type="csv"
            >
              <v-card>
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        class="text-left"
                        v-text="downloadAllText"
                      ></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar>
                      <img
                        class="downloadImage justify-right"
                        :src="downloadImage"
                      />
                    </v-list-item-avatar>
                  </v-list-item>
                </v-list>
              </v-card>
            </download-excel>
          </v-col>

          <div>
            <h3>Audit Samples</h3>
            <v-data-table
              :headers="auditSampleHeaders"
              :items="auditSamples"
              class="elevation-1"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ props.header.text }}</span>
                  </template>
                  <span>{{ props.header.text }}</span>
                </v-tooltip>
              </template>

              <template v-slot:item.hasPhotos="{ item }">
                <td v-if="item.photosFound" class="text-xs-left">
                  <v-icon @click="getAllPhotosByAuditSampleId(item.id)"
                    >check_circle_outline</v-icon
                  >
                </td>
                <td v-else class="text-xs-left"></td>
              </template>

              <template v-slot:item.hasSignature="{ item }">
                <td v-if="item.signatureFound" class="text-xs-left">
                  <v-icon @click="getAllSignaturesByAuditSampleId(item.id)"
                    >check_circle_outline</v-icon
                  >
                </td>
                <td v-else class="text-xs-left"></td>
              </template>

              <template v-slot:item.actions="{ item }">
                <td class="text-xs-left">
                  <v-icon v-if="item.notes" @click="showNotes(item)"
                    >mdi-message-bulleted</v-icon
                  >
                  <v-icon v-else>mdi-message-bulleted-off</v-icon>
                  <v-icon @click="signLink(item.id)">assignment</v-icon>
                  <v-icon
                    @click="
                      editPrompt(
                        item.id,
                        item.doctorName,
                        item.doctorAddress,
                        item.nth,
                        item.signatureText,
                        item.pocCompanyID,
                        item.opportunityID,
                        item.jobNumber,
                        item.extraLink
                      )
                    "
                    >edit</v-icon
                  >
                  <v-icon
                    @click="
                      deletePrompt(item.id, item.doctorName, item.doctorAddress)
                    "
                    >delete</v-icon
                  >
                </td>
              </template>
            </v-data-table>
          </div>
          <v-layout row wrap>
            <v-flex xs6 class="mt-3">
              <div>
                <h3>Upload CSV</h3>
                <form ref="uploadForm" id="uploadForm" class="mt-3">
                  <v-flex class="mb-3" xs12>
                    <input
                      type="file"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      name="csv"
                      @change="selectFile"
                    />
                  </v-flex>
                  <v-btn
                    type="button"
                    color="success"
                    @click="submitCSV"
                    :disabled="submittingCSVProgress"
                    >Submit</v-btn
                  >

                  <v-progress-linear
                    v-if="submittingCSVProgress"
                    :indeterminate="submittingCSVProgress"
                  ></v-progress-linear>
                </form>
              </div>
            </v-flex>
            <v-flex xs6 class="mt-3">
              <div>
                <h3>Add Single Audit Sample</h3>
                <form>
                  <v-text-field
                    v-model="nth"
                    :error-messages="nthErrors"
                    :counter="100"
                    label="nth"
                    required
                    @input="$v.nth.$touch()"
                    @blur="$v.nth.$touch()"
                  ></v-text-field>
                  <v-text-field
                    v-model="doctorName"
                    :error-messages="doctorNameErrors"
                    :counter="100"
                    label="Doctor Name"
                    required
                    @input="$v.doctorName.$touch()"
                    @blur="$v.doctorName.$touch()"
                  ></v-text-field>
                  <v-text-field
                    v-model="doctorAddress"
                    :error-messages="doctorAddressErrors"
                    :counter="200"
                    label="Doctor Address"
                    required
                    @input="$v.doctorAddress.$touch()"
                    @blur="$v.doctorAddress.$touch()"
                  ></v-text-field>
                  <v-btn
                    :disabled="submittingProgress"
                    class="success"
                    @click="submit"
                    >submit</v-btn
                  >
                  <v-btn
                    :disabled="submittingProgress"
                    class="error ml-3"
                    @click="clear"
                    >clear</v-btn
                  >

                  <v-progress-linear
                    v-if="submittingProgress"
                    :indeterminate="submittingProgress"
                  ></v-progress-linear>
                </form>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="450">
          <v-card>
            <v-card-title class="headline"
              >Are you sure you want to delete the following Audit Sample? It
              will delete all photos associated with this sample from both image
              storage and the database!</v-card-title
            >
            <v-card-text>Doctor Name: {{ this.deleteName }}</v-card-text>
            <v-card-text>Doctor Address: {{ this.deleteAddress }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="keepOnPrompt"
                >Keep</v-btn
              >
              <v-btn color="error" text @click="deleteOnPrompt">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog v-model="editDialog" persistent max-width="720">
          <v-card>
            <v-card-title class="headline">Edit:</v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editNth"
                      label="nth"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editName"
                      label="Doctor Name"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editAddress"
                      label="Doctor Address"
                      required
                    ></v-text-field>
                  </v-flex>
                  
                    <p>Signature Text:</p>
                  </v-flex>
                  <v-flex xs12 class="pb-2">
                    <vue-editor
                      class="editor pb-2"
                      v-model="editSignatureText"
                      :editorToolbar="customToolbar"
                    ></vue-editor>
                  </v-flex>
                  <v-flex xs6 class="mt-10">
                    <v-text-field
                      v-model="editPocCompanyID"
                      label="POC Company ID"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="mt-10">
                    <v-text-field
                      v-model="editOpportunityID"
                      label="Opportunity ID"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      v-model="editJobNumber"
                      label="Job Number"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      v-model="editExtraLink"
                      label="Extra Link"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="stopEditingOnPrompt"
                >Stop Editing</v-btn
              >
              <v-btn color="green darken-1" text @click="saveOnPrompt"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center v-if="auditEvent !== null">
        <v-dialog v-model="editAuditEventDialog" persistent max-width="450">
          <v-card>
            <v-card-title class="headline">Edit:</v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-select
                      v-model="editAuditEventMonth"
                      :items="[
                        {
                          name: 'January',
                          value: 0,
                        },
                        {
                          name: 'February',
                          value: 1,
                        },
                        {
                          name: 'March',
                          value: 2,
                        },
                        {
                          name: 'April',
                          value: 3,
                        },
                        {
                          name: 'May',
                          value: 4,
                        },
                        {
                          name: 'June',
                          value: 5,
                        },
                        {
                          name: 'July',
                          value: 6,
                        },
                        {
                          name: 'August',
                          value: 7,
                        },
                        {
                          name: 'September',
                          value: 8,
                        },
                        {
                          name: 'October',
                          value: 9,
                        },
                        {
                          name: 'November',
                          value: 10,
                        },
                        {
                          name: 'December',
                          value: 11,
                        },
                      ]"
                      item-text="name"
                      item-value="value"
                      label="Audit Month"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="editAuditEventYear"
                      :items="[2019, 2020, 2021, 2022, 2023, 2024, 2025]"
                      label="Audit Year"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="auditEvent.drugName"
                      label="Drug Name"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="auditEvent.projectDesignation"
                      :items="['Campaign', 'Network']"
                      label="Project Designation"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="auditEvent.auditorActive"
                      :items="[true, false]"
                      label="Uploads Allowed"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="auditEvent.eventActive"
                      :items="[true, false]"
                      label="Sharing Allowed"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="auditEvent.completed"
                      :items="[true, false]"
                      label="Completed"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="auditEvent.signatureRequired"
                      :items="[true, false]"
                      label="Signature Required"
                      required
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="stopEditingAuditEvenOnPrompt"
                >Stop Editing</v-btn
              >
              <v-btn color="green darken-1" text @click="saveAuditEventOnPrompt"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-dialog v-model="previewPhotosDialog" width="700">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title
            >Photos</v-card-title
          >

          <v-flex
            v-for="photo in previewPhotos"
            :key="photo._id"
            xs12
            class="mb-2 pr-2 pl-2"
          >
            <v-card>
              <v-img
                contain
                aspect-ratio="1.0"
                :id="photo.photo"
                v-if="photo.photo !== null"
                :src="photo.photo"
              />
              <v-card-title primary-title>
                <div v-if="photo.failed === 'FAILED'">
                  <h3 class="headline mb-0 red--text">Alternate:</h3>
                </div>
              </v-card-title>
              <v-card-text>
                <p>
                  Date and Time from Database 
                  (Time Zone: {{moment.tz.guess()}}):
                  {{ moment(photo.date).format("MMMM Do YYYY, h:mm:ss a") }}
                </p>
                <p v-if="photo.exifDateTime">
                  Date and Time from EXIF:
                  {{ photo.exifDateTime }}
                </p>
                <p v-if="!photo.exifDateTime">
                  Date and Time from EXIF: Not Avaliable
                </p>
                <p>
                  <a :href="`/map?lat=${photo.geolocation_lat}&long=${photo.geolocation_long}&name=DB&address=DB`" target="_blank">
                    Lat and Long from Database:
                    {{ photo.geolocation_lat }} / {{ photo.geolocation_long }}
                  </a>
                </p>
                <p v-if="photo.exifLat ||  photo.exifLong">
                  <a :href="`/map?lat=${photo.exifLat}&long=${photo.exifLong}&name=EXIF&address=EXIF`" target="_blank">
                    Lat and Long from EXIF:
                    {{ photo.exifLat.toFixed(7) }} / {{ photo.exifLong.toFixed(7) }}
                  </a>
                </p>
                <p v-if="!photo.exifLat && !photo.exifLong">
                  Lat and Long from EXIF: Not Avaliable
                </p>
                <p v-if="photo.label">Label: {{ photo.label }}</p>
                <v-btn
                  v-if="photo.photo !== null"
                  text
                  @click="rotateImage(photo)"
                >
                  Rotate Image
                  <v-icon>rotate_right</v-icon>
                </v-btn>
                <div v-if="!photo.hidden">
                  <v-btn text @click="toggleHidePhoto(photo)">Hide Image</v-btn>
                </div>
                <div v-else>
                  <v-btn text @click="toggleHidePhoto(photo)"
                    >Unhide Image</v-btn
                  >
                </div>

                <div>
                  <v-btn text @click="togglePhotoStatus(photo)"
                    >Toggle Pass/Fail Status</v-btn
                  >
                </div>

                <div>
                  <v-btn text @click="showPhotoNotes(photo)"
                    >Show Photo Notes</v-btn
                  >
                </div>  

                <MovePhoto :photo="photo" />

                <v-btn
                  color="error"
                  text
                  @click="deleteItemPrompt(photo, 'photo')"
                  >Delete Item</v-btn
                >
              </v-card-text>
            </v-card>
          </v-flex>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="previewPhotosDialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="previewSignaturesDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title
            >Signatures</v-card-title
          >

          <v-flex
            v-for="signature in previewSignatures"
            :key="signature._id"
            xs12
            class="mb-2 pr-2 pl-2"
          >
            <v-card>
              <v-img
                contain
                aspect-ratio="1.0"
                v-bind:src="signature.signature"
              />

              <v-card-text>
                <v-btn
                  color="error"
                  text
                  @click="deleteItemPrompt(signature, 'signature')"
                  >Delete Item</v-btn
                >
              </v-card-text>
            </v-card>
          </v-flex>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="previewSignaturesDialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteItemPromptBool" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title
            >Are you sure?</v-card-title
          >

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="closePrompts()"
              >Close</v-btn
            >
            <v-btn color="error" text @click="deleteItem()">Delete Item</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showNotesDialog" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">Notes (Legacy)</v-card-title>
          <vue-editor
            class="pb-2"
            v-model="editNotes"
            :editorToolbar="customToolbar"
          ></vue-editor>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="saveNotes">Save</v-btn>
            <v-btn color="error" text @click="showNotesDialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showPhotoNotesDialog" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">Notes (Photo)</v-card-title>
          <vue-editor
            class="pb-2"
            v-model="editPhotoNotes"
            :editorToolbar="customToolbar"
          ></vue-editor>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="showPhotoNotesDialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-content>
</template>

<script>
/* eslint-disable no-console */
import _ from "lodash";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";
import moment from "moment";
import MovePhoto from "@/components/MovePhoto.vue";

export default {
  mixins: [validationMixin],
  validations: {
    doctorName: { required, maxLength: maxLength(100) },
    doctorAddress: { required, maxLength: maxLength(200) },
    nth: { required, maxLength: maxLength(100) },
  },
  name: "AdminEvent",
  data: () => ({
    token: null,
    auditEvent: null,
    auditSamples: [],
    auditSampleHeaders: [
      { text: "Has Photos", value: "hasPhotos", sortable: false },
      { text: "Has Signature", value: "hasSignature", sortable: false },
      { text: "Nth", value: "nth", sortable: true },
      { text: "Name", value: "doctorName", sortable: true },
      { text: "Address", value: "doctorAddress", sortable: true },
      { text: "Actions", value: "actions", sortable: false },
    ],
    managerID: null,
    CSV: null,
    submittingCSVProgress: false,
    doctorName: "",
    doctorAddress: "",
    submittingProgress: false,
    dialog: false,
    deleteID: "",
    deleteName: "",
    deleteAddress: "",
    editDialog: false,
    editID: "",
    editName: "",
    editAddress: "",
    editNth: "",
    editPocCompanyID: "",
    editOpportunityID: "",
    editJobNumber: "",
    editExtraLink: "",
    editAuditEventDialog: false,
    editAuditEventMonth: null,
    editAuditEventYear: null,
    previewPhotos: [],
    previewPhotosDialog: false,
    deleteItemPromptBool: false,
    itemToDelete: null,
    itemToDeleteType: null,
    nth: "",
    previewSignatures: [],
    previewSignaturesDialog: false,
    editSignatureText: null,
    customToolbar: [["bold", "italic", "underline"]],
    config: {
      placeholder: "Enter signature notes here...",
    },
    stats: null,
    showNotesDialog: false,
    editNotes: null,
    showPhotoNotesDialog: false,
    editPhotoNotes: null,
    photos: [],
    downloadPhotos: [],
    downloadName: "",
    loadingDownload: false,
    photosLoading: true,
    downloadAllText: "Download All",
    downloadImage: require("@/assets/download.png"),
  }),
  components: {
    VueEditor,
    MovePhoto,
  },
  computed: {
    getBaseUrl() {
      return this.$store.getters.getBaseUrl;
    },
    doctorNameErrors() {
      const errors = [];
      if (!this.$v.doctorName.$dirty) return errors;
      !this.$v.doctorName.maxLength &&
        errors.push("Name must be at most 50 characters long");
      !this.$v.doctorName.required && errors.push("Name is required.");
      return errors;
    },
    doctorAddressErrors() {
      const errors = [];
      if (!this.$v.doctorAddress.$dirty) return errors;
      !this.$v.doctorAddress.maxLength &&
        errors.push("Address must be at most 50 characters long");
      !this.$v.doctorAddress.required && errors.push("Address is required.");
      return errors;
    },
    nthErrors() {
      const errors = [];
      if (!this.$v.nth.$dirty) return errors;
      !this.$v.nth.maxLength &&
        errors.push("Address must be at most 100 characters long");
      !this.$v.nth.required && errors.push("nth is required.");
      return errors;
    },
  },
  mounted() {
    this.managerID = this.$route.params.id;
    for (var i = 0, len = localStorage.length; i < len; ++i) {
      if (localStorage.key(i).indexOf("adal.access.token.key") !== -1) {
        this.token = localStorage.getItem(localStorage.key(i));
      }
    }
    this.getAuditEventInfo();
    this.getAllAuditSamples();
  },
  methods: {
    submit() {
      this.$v.$touch();
      this.addAuditSample();
    },
    clear() {
      this.$v.$reset();
      this.nth = "";
      this.doctorName = "";
      this.doctorAddress = "";
    },
    getAuditEventInfo() {
      let config = {
        url: `${this.getBaseUrl}/admin/getAuditEventbyManagerID/${this.managerID}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.auditEvent = response.data;
          } else {
            // todo Improve Error Handling
          }
        })
        .catch((err) => {
          console.log(err);
          // todo Improve Error Handling
        });
    },
    getAllAuditSamples() {
      let config = {
        url: `${this.getBaseUrl}/admin/getAuditSamplesByManagerId/${this.managerID}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            let results = response.data;
            for(let r of results){
              if(r.photosID){
                _.set(r, 'photosFound', true);
              }else{
                _.set(r, 'photosFound', false);
              }

              if(r.signatureID){
                _.set(r, 'signatureFound', true);
              }else{
                _.set(r, 'signatureFound', false);
              }

              _.set(r, 'AuditEvent.drugName', r.drugName);
              _.set(r, 'AuditEvent.projectDesignation', r.projectDesignation);
              _.set(r, 'AuditEvent.auditDate', r.auditDate);
            }
            this.auditSamples = results;
            this.generateStats();
            this.getPhotos();
          } else {
            // todo Improve Error Handling
          }
        })
        .catch((err) => {
          console.log(err);
          // todo Improve Error Handling
        });
    },
    selectFile(e) {
      let CSV = e.target.files[0];
      this.CSV = CSV;
    },
    submitCSV() {
      this.submittingCSVProgress = true;
      let formData = new FormData();
      formData.append("excelFile", this.CSV);
      formData.append("managerID", this.managerID);

      let config = {
        url: `${this.getBaseUrl}/admin/addAuditSamplesByCSV`,
        method: "POST",
        data: formData,
        headers: {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": "multipart/form-data",
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 201) {
            this.getAllAuditSamples();
            this.resetForm();
            this.submittingCSVProgress = false;
          } else {
            alert("ERROR");
            this.resetForm();
            this.submittingCSVProgress = false;
          }
        })
        .catch((err) => {
          console.log(err);
          alert("ERROR");
          this.resetForm();
          this.submittingCSVProgress = false;
        });
    },
    resetForm() {
      this.$refs.uploadForm.reset();
    },
    addAuditSample() {
      this.submittingProgress = true;
      let data = {
        nth: this.nth,
        managerID: this.managerID,
        doctorName: this.doctorName,
        doctorAddress: this.doctorAddress,
      };
      let config = {
        url: `${this.getBaseUrl}/admin/addAuditSample`,
        method: "POST",
        data: data,
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 201) {
            this.getAllAuditSamples();
            this.clear();
            this.submittingProgress = false;
          } else {
            alert("ERROR");
            this.clear();
            this.submittingProgress = false;
          }
        })
        .catch((err) => {
          console.log(err);
          alert("ERROR");
          this.clear();
          this.submittingProgress = false;
        });
    },
    deletePrompt(id, name, address) {
      this.deleteID = id;
      this.deleteName = name;
      this.deleteAddress = address;
      this.dialog = true;
    },
    resetPrompt() {
      this.deleteID = "";
      this.deleteName = "";
      this.deleteAddress = "";
      this.dialog = false;
    },
    keepOnPrompt() {
      this.resetPrompt();
    },
    deleteOnPrompt() {
      let config = {
        url: `${this.getBaseUrl}/admin/deleteAuditSample/${this.deleteID}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.getAllAuditSamples();
            this.resetPrompt();
          } else {
            alert("ERROR");
            this.resetPrompt();
          }
        })
        .catch((err) => {
          console.log(err);
          alert("ERROR");
          this.resetPrompt();
        });
    },
    editPrompt(id, name, address, nth, signatureText, pocCompanyID, opportunityID, jobNumber, extraLink) {
      this.editID = id;
      this.editName = name;
      this.editAddress = address;
      this.editNth = nth;
      this.editSignatureText = signatureText;
      this.editPocCompanyID = pocCompanyID;
      this.editOpportunityID = opportunityID;
      this.editJobNumber = jobNumber;
      this.editExtraLink = extraLink;

      this.editDialog = true;
    },
    resetEditPrompt() {
      this.editID = "";
      this.editName = "";
      this.editAddress = "";
      this.editNth = "";
      this.editPocCompanyID = "";
      this.editOpportunityID = "";
      this.editJobNumber = "";
      this.editExtraLink = "";
      this.editSignatureText = null;
      this.editDialog = false;
    },
    stopEditingOnPrompt() {
      this.resetEditPrompt();
    },
    saveOnPrompt() {
      let config = {
        url: `${this.getBaseUrl}/admin/editAuditSample`,
        method: "PUT",
        data: {
          id: this.editID,
          nth: this.editNth,
          doctorName: this.editName,
          doctorAddress: this.editAddress,
          signatureText: this.editSignatureText,
          pocCompanyID: this.editPocCompanyID,
          opportunityID: this.editOpportunityID,
          jobNumber: this.editJobNumber,
          extraLink: this.editExtraLink,
        },
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.getAllAuditSamples();
            this.resetEditPrompt();
          } else {
            alert("ERROR");
            this.resetEditPrompt();
          }
        })
        .catch((err) => {
          console.log(err);
          alert("ERROR");
          this.resetEditPrompt();
        });
    },
    editAuditEvent() {
      let d = new Date(this.auditEvent.auditDate);
      this.editAuditEventMonth = d.getMonth();
      this.editAuditEventYear = d.getFullYear();
      this.editAuditEventDialog = true;
    },
    stopEditingAuditEvenOnPrompt() {
      this.editAuditEventDialog = false;
    },
    saveAuditEventOnPrompt() {
      this.auditEvent.auditDate = new Date(
        this.editAuditEventYear,
        this.editAuditEventMonth,
        5
      );

      // Refresh page on error submitting to get old values back
      let config = {
        url: `${this.getBaseUrl}/admin/editAuditEvent`,
        method: "PUT",
        data: this.auditEvent,
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.getAuditEventInfo();
            this.getAllAuditSamples();
          } else {
            alert("ERROR");
            location.reload();
          }
        })
        .catch((err) => {
          console.log(err);
          alert("ERROR");
          location.reload();
        });

      this.editAuditEventDialog = false;
    },
    getAllPhotosByAuditSampleId(id) {
      let config = {
        url: `${this.getBaseUrl}/admin/getAllPhotosByAuditSampleId/${id}?fetchEXIF=true`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.previewPhotos = response.data;
            this.previewPhotosDialog = true;
          } else {
            // todo Improve Error Handling
          }
        })
        .catch((err) => {
          console.log(err);
          // todo Improve Error Handling
        });
    },
    getAllSignaturesByAuditSampleId(id) {
      let config = {
        url: `${this.getBaseUrl}/admin/getAllSignaturesByAuditSampleId/${id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.previewSignatures = response.data;
            this.previewSignaturesDialog = true;
          } else {
            // todo Improve Error Handling
          }
        })
        .catch((err) => {
          console.log(err);
          // todo Improve Error Handling
        });
    },
    rotateImage(photo) {
      if (typeof photo.angle === "undefined") {
        photo.angle = 0;
      }
      photo.angle = photo.angle + 90;
      document
        .getElementById(photo.photo)
        .setAttribute("style", `transform:rotate(${photo.angle}deg)`);
    },
    deleteItemPrompt(item, type) {
      this.itemToDelete = item;
      this.itemToDeleteType = type;
      this.deleteItemPromptBool = true;
    },
    closePrompts() {
      this.deleteItemPromptBool = false;
      this.previewPhotosDialog = false;
      this.previewSignaturesDialog = false;
      this.previewSignatures = [];
      this.previewPhotos = [];
    },
    deleteItem() {
      let config;
      if (this.itemToDeleteType === "photo") {
        config = {
          url: `${this.getBaseUrl}/admin/deletePhoto`,
          method: "POST",
          data: {
            id: this.itemToDelete.id,
            photoKey: this.itemToDelete.photoKey,
          },
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        };
      }
      if (this.itemToDeleteType === "signature") {
        config = {
          url: `${this.getBaseUrl}/admin/deleteSignature`,
          method: "POST",
          data: {
            id: this.itemToDelete.id,
          },
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        };
      }

      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.getAllAuditSamples();
            this.closePrompts();
            this.itemToDeleteType = null;
            this.itemToDelete = null;
          } else {
            alert("Error deleting Item!");
          }
        })
        .catch((err) => {
          console.log(err);
          alert("Error deleting Item!");
        });
    },
    signLink(id) {
      this.$router.push(`/sign/${this.auditEvent.auditorID}?q=${id}`);
    },
    toggleHidePhoto(photo) {
      photo.hidden = !photo.hidden;
      let config = {
        url: `${this.getBaseUrl}/admin/editPhoto`,
        method: "PUT",
        data: photo,
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.getAllAuditSamples();
          } else {
            alert("ERROR");
          }
        })
        .catch((err) => {
          console.log(err);
          alert("ERROR");
        });
    },
    generateStats() {
      let auditSamplesWithPhotos = 0;
      _.forEach(this.auditSamples, (auditSample) => {
        if (auditSample.photosFound) {
          auditSamplesWithPhotos += 1;
        }
      });

      let auditSamplesWithPhotosPercentage =
        (auditSamplesWithPhotos / this.auditSamples.length) * 100;

      auditSamplesWithPhotosPercentage =
        Math.round(auditSamplesWithPhotosPercentage * 10) / 10;

      this.stats = {
        auditSamplesWithPhotos: auditSamplesWithPhotos,
        numberOfAuditSamples: this.auditSamples.length,
        auditSamplesWithPhotosPercentage: auditSamplesWithPhotosPercentage,
      };
    },
    showNotes(item) {
      this.editID = item.id;
      this.editName = item.name;
      this.editAddress = item.address;
      this.editNth = item.nth;
      this.editSignatureText = item.signatureText;
      this.editPocCompanyID = item.pocCompanyID;
      this.editOpportunityID = item.opportunityID;
      this.editJobNumber = item.jobNumber;
      this.editExtraLink = item.extraLink;

      this.editNotes = item.notes;
      this.showNotesDialog = true;
    },
    saveNotes() {
      let config = {
        url: `${this.getBaseUrl}/admin/editAuditSample`,
        method: "PUT",
        data: {
          id: this.editID,
          nth: this.editNth,
          doctorName: this.editName,
          doctorAddress: this.editAddress,
          signatureText: this.editSignatureText,
          notes: this.editNotes,
          pocCompanyID: this.editPocCompanyID,
          opportunityID: this.editOpportunityID,
          jobNumber: this.editJobNumber,
          extraLink: this.editExtraLink,
        },
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.getAllAuditSamples();
            this.resetEditPrompt();
            this.editNotes = null;
            this.showNotesDialog = false;
          } else {
            alert("ERROR");
            this.resetEditPrompt();
            this.editNotes = null;
            this.showNotesDialog = false;
          }
        })
        .catch((err) => {
          console.log(err);
          alert("ERROR");
          this.resetEditPrompt();
          this.editNotes = null;
          this.showNotesDialog = false;
        });
    },
    showPhotoNotes(item) {
      this.editPhotoNotesId = item.id;

      this.editPhotoNotes = item.notes;
      this.showPhotoNotesDialog = true;
    },
    getPhotos() {
      let config = {
        url: `${this.getBaseUrl}/photos/${this.auditEvent.sharingID}`,
        method: "GET",
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            console.log(response.data);
            this.photos = response.data;
            this.generateDownloadPhotos();
            this.photosLoading = false;
            this.loadingSignatures = false;
          } else {
            // handle error
          }
        })
        .catch((err) => {
          // eslint-disable-next-line
          console.log(err);
          // handle error
        });
    },
    generateDownloadPhotos() {
      let photos = [];
      _.forEach(this.auditSamples, (auditSample) => {
        const rawNotes = auditSample.notes;
        let sanitizedNotes = "";
        if(rawNotes){
          sanitizedNotes = rawNotes.replace(/<[^>]*>?/gm, '');
        }

        photos.push({
          "Has Photos": _.startCase(auditSample.photosFound),
          Nth: auditSample.nth,
          "Drug Name": auditSample.AuditEvent.drugName,
          "Project Designation": auditSample.AuditEvent.projectDesignation,
          "Audit Date": moment(auditSample.AuditEvent.auditDate).format(
            "MMMM YYYY"
          ),
          "Doctor Name": auditSample.doctorName,
          "Doctor Address": auditSample.doctorAddress,
          "Photo Type": "",
          Latitude: "",
          Longitude: "",
          notes: sanitizedNotes,
          "Date And Time": "",
          "Photo Link": "",
          "Photo Notes": "",
        });
      });

      if (this.photos.length > 0) {
        this.downloadName =
          this.photos[0].AuditEvent.drugName +
          " " +
          moment(this.photos[0].AuditEvent.auditDate).format("MMMM YYYY") +
          ".csv";
      }

      _.forEach(this.photos, (photo) => {
        let isFailed;
        if (photo.failed === "FAILED") {
          isFailed = "Alternate";
        } else {
          isFailed = "Primary";
        }

        const rawPhotoNotes = photo.notes;
        let sanitizedPhotoNotes = "";
        if(rawPhotoNotes){
          sanitizedPhotoNotes = rawPhotoNotes.replace(/<[^>]*>?/gm, '');
        }

        let obj = {
          "Has Photos": "True",
          Nth: photo.AuditSample.nth,
          "Drug Name": photo.AuditEvent.drugName,
          "Project Designation": photo.AuditEvent.projectDesignation,
          "Audit Date": moment(photo.AuditEvent.auditDate).format("MMMM YYYY"),
          "Doctor Name": photo.AuditSample.doctorName,
          "Doctor Address": photo.AuditSample.doctorAddress,
          "Photo Type": isFailed,
          Latitude: photo.geolocation_lat,
          Longitude: photo.geolocation_long,
          "Date And Time": moment(photo.date).format("MMMM Do YYYY, h:mm:ss a"),
          "Photo Link": photo.photo,
          "Photo Notes": sanitizedPhotoNotes

        };
        photos.push(obj);
      });
      photos = _.orderBy(photos, ["Nth"], ["asc"]);
      this.downloadPhotos = photos;
      this.loadingDownload = true;
    },
    togglePhotoStatus(photo) {
      let config = {
        url: `${this.getBaseUrl}/admin/togglePhotoStatus/${photo.id}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.getPhotos();
            this.previewPhotosDialog = false;
          } else {
            // handle error
          }
        })
        .catch((err) => {
          // eslint-disable-next-line
          console.log(err);
          // handle error
        });
    }
  },
  
};
</script>

<style scoped>
.editor {
  width: 100%;
  height: 175px;
}
</style>

